import { render, staticRenderFns } from "./PrepaidPlanModal.vue?vue&type=template&id=61297c90&"
import script from "./PrepaidPlanModal.vue?vue&type=script&lang=js&"
export * from "./PrepaidPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports